import React, { useState } from 'react'
import Button from '../button'
import Typography from '../typography'
import { DropDownContainer, HorizontalNavContainer, SimpleNavWrapper } from './style'

interface ISimpleNav {
  activeButton: number
  setActiveButton: (value: number) => void
  allButtons: { label: string }[]
}

const SimpleNav = (props: ISimpleNav) => {
  const { activeButton, setActiveButton, allButtons } = props
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false)

  return (
    <SimpleNavWrapper data-cy="SimpleNav">
      <HorizontalNavContainer>
        {allButtons &&
          allButtons.map((btn: any, index: number) => {
            return (
              <button
                key={`Nav_Buttons__${index}`}
                onClick={() => setActiveButton(index)}
                className={`Nav_Buttons-Styles ${activeButton === index ? 'active' : ''}`}>
                {btn && btn.label && <Typography type="label">{btn.label}</Typography>}
              </button>
            )
          })}
      </HorizontalNavContainer>
      <DropDownContainer className="desktop--hide">
        <div className="selection__container">
          <div className="selection__dropdown-container">
            <button
              onClick={() => {
                setMobileMenuIsOpen(!mobileMenuIsOpen)
              }}
              className="Menu-item js-Menu-item desktop--hide">
              {allButtons && allButtons[activeButton] && allButtons[activeButton].label && (
                <Typography className="selected__menu-item" type="label">
                  {allButtons[activeButton].label}
                </Typography>
              )}
            </button>
            <div
              className={`selection__dropdown-item-container ${
                mobileMenuIsOpen ? 'is-active' : ''
              }`}>
              {allButtons &&
                allButtons.map((item, index) => {
                  return (
                    <Button
                      key={`Dropdown-${index}`}
                      icon={false}
                      text={item.label ? item.label : ''}
                      type="secondary"
                      size="medium"
                      theme="dark"
                      clickHandler={() => {
                        setMobileMenuIsOpen(!mobileMenuIsOpen)
                        setActiveButton(index)
                      }}
                      className={`Dropdown__Tab__BTNS`}
                    />
                  )
                })}
            </div>
          </div>
        </div>
      </DropDownContainer>
    </SimpleNavWrapper>
  )
}

export default SimpleNav
